export default "__VITE_ASSET__CaP_gQn7__"